import React, { FC } from "react";

import { ApiMembersUnreadNotificationCountsType } from "~/domains";

import { Icon, IconType, Link } from "~/ui";

type PropsType = {
  label: string;
  href: string;
  breadCrumbText: string;
  unreadNotification?: ApiMembersUnreadNotificationCountsType;
  icon?: IconType;
};

export const getUnreadCount = (
  label: string,
  unreadNotification: ApiMembersUnreadNotificationCountsType | undefined,
) => {
  switch (label) {
    case "メモログ":
    case "メモログ確認":
      return (
        unreadNotification?.deliveryNotifications.insightPostNotificationCount
          .total || 0
      );
    case "チャレンジ":
    case "チャレンジ確認":
      return (
        unreadNotification?.deliveryNotifications
          .focusChallengePostNotificationCount.total || 0
      );
    case "チェックアウト":
    case "チェックアウト確認":
      return (
        unreadNotification?.deliveryNotifications
          .employeeSurveySubmissionNotificationCount.total || 0
      );
    case "コンディション":
    case "コンディション確認":
      return (
        unreadNotification?.deliveryNotifications
          .employeeConditionSubmissionNotificationCount.total || 0
      );
    case "改善・相談":
      return (
        unreadNotification?.deliveryNotifications.kaizenIdeaNotificationCount
          .total || 0
      );
    case "KPI・KGI":
      return (
        unreadNotification?.deliveryNotifications.kpiTermNotificationCount
          .total || 0
      );
    case "ナレッジシェア":
      return (
        unreadNotification?.deliveryNotifications
          .insightPostSharedEmployeeNotificationCount.total || 0
      );
    case "本部の発信":
      return (
        unreadNotification?.deliveryNotifications
          .knowledgeInsightPostNotificationCount.roles.owner || 0
      );
    case "部署の発信":
      return (
        unreadNotification?.deliveryNotifications
          .knowledgeInsightPostNotificationCount.roles.manager || 0
      );
    case "ライブラリ":
      return (
        unreadNotification?.deliveryNotifications
          .documentFileCategoryNotificationCount.total || 0
      );
    case "ロールプレイング":
      return 0;
    case "1on1・MTG":
      return 0;
    case "Q&A":
      return (
        unreadNotification?.deliveryNotifications
          .questionAnswerCategoryNotificationCount.total || 0
      );
    case "スキルマップ":
      return unreadNotification
        ? unreadNotification.deliveryNotifications
            .skillEvaluationStandardSummaryCategoryNotificationCount.total +
            unreadNotification.deliveryNotifications
              .skillEvaluationTermNotificationCount.total
        : 0;
    case "ブログ":
      return (
        unreadNotification?.deliveryNotifications
          .salesConceptCategoryNotificationCount.total || 0
      );
    default:
      return 0;
  }
};

export const SidebarLink: FC<PropsType> = ({
  breadCrumbText,
  unreadNotification,
  label,
  href,
  icon,
}: PropsType) => {
  const unreadCount = getUnreadCount(label, unreadNotification);
  const isActive = label === breadCrumbText;

  return (
    <Link
      key={label}
      to={href}
      className={`group flex items-center justify-between mx-2 rounded-lg text-sm font-medium px-3 py-2 ${
        isActive
          ? "bg-primary-600 text-white"
          : "text-secondary-900 hover:bg-primary-300"
      }`}
    >
      <span className="flex items-center gap-2.5 min-w-0">
        {icon && (
          <Icon
            icon={icon}
            size="1.1rem"
            color={isActive ? "text-white" : "text-secondary-600"}
            className={`shrink-0 ${!isActive ? "group-hover:text-secondary-900" : ""}`}
          />
        )}
        <span className="truncate">{label}</span>
      </span>
      {!!unreadCount && (
        <span
          className={`ml-2 shrink-0 inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full text-xs font-semibold leading-none ${
            isActive ? "bg-white text-primary-600" : "bg-icon-heart text-white"
          }`}
        >
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </Link>
  );
};
